
import React from 'react';

import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import OurStoryPage from './pages/OurStoryPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (

    <BrowserRouter>
    <ScrollToTop />

      <Routes>

        <Route
          path="/"
          element={<HomePage />}
        />

        <Route
          path="/services"
          element={<ServicesPage />}
        />

        <Route
          path="/ourstory"
          element={<OurStoryPage />}
        />

      </Routes>

    </BrowserRouter>

  );
}

export default App;



